import { useTextTranslation } from "../../utils/useTextTranslation";
import { flowCopy } from "../../utils/flowCopy";
import useMountedRef from "../../utils/useMountedRef";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams, NavLink, useHistory } from "react-router-dom";
import { SessionContext } from "../../context/SessionContext";
import {
  getCatchupById,
  watchCatchup,
  getCatchupEpisodesBySeason
} from "../../api/catchup/catchup";
import {
  getTrailerPlayUrlById
} from "../../api/vod/vod";
import useQuery from "../../utils/useQuery";
import { prettyTimeFormatter } from "../../utils/prettyTimeFormatter";
import getParentalAdvisoryElements from "../../utils/getParentalAdvisory";
import { getTrailerAudioOnGlobal, setWhereFrom } from "../../statics/config";
import { getPosterUrlByType } from "../../utils/findPoster";
import localizationStrings from "../../statics/localization";
import Modal from "../modal/Modal";
import ImageView from "../imageView";
import Carousel from "../carousel";
import TrailerPlayer from "../trailerPlayer";
import VideoPlayer from "../videoPlayer/VideoPlayer";
import MiniVodDetail from "../miniVodDetail/MiniVodDetail";
import FavoriteAction from "../favoriteAction";
import LikeAction from "../likeAction";
import ShareAction from "../ShareAction/ShareAction";
import Payment from "../payment/Payment";
import Notification from "../notification";
import defaultDetailPoster from "../../assets/images/default-vod-horizontal-poster.png";
import defaultCastPoster from "../../assets/images/default-cast-poster.png";
import mainLoadingGif from "../../assets/loading.gif";
import StarIcon from "../../assets/icons/svg/StarIcon";
import RtukAgeIcon from "../../assets/icons/svg/RtukAgeIcon";
import RtukGeneralIcon from "../../assets/icons/svg/RtukGeneralIcon";
import RtukSevenAgeIcon from "../../assets/icons/svg/RtukSevenAgeIcon";
import RtukThirteenAgeIcon from "../../assets/icons/svg/RtukThirteenAgeIcon";
import ArrowDownIcon from "../../assets/icons/svg/ArrowDownIcon";
import PackageIcon from "../../assets/icons/svg/PackageIcon";
import NewEpisodeItem from "../newEpisodeItem/NewEpisodeItem";

const playerOptions = {
  // fill: true,
  fluid: true,
  responsive: true,
  preload: "auto",
  controls: true,
  liveui: false,
  autoplay: true,
  playbackRates: [0.5, 1, 1.5, 2],
  disablePictureInPicture: false,
  controlBar: {
    pictureInPictureToggle: true
  },
  html5: {
    nativeTextTracks: true,
    dash: {
      useTTML: true
    }
  }
};

const CatchupVodDetail = () => {
  const translateText = useTextTranslation();
  const mounted = useMountedRef();
  const contentVersion = useRef(0), episodeVersion = useRef(0), nextVersion = useRef(0), watchVersion = useRef(0);
  const watchPending = useRef(false);
  const [loadError, setLoadError] = useState(false);
  const [episodeError, setEpisodeError] = useState(false);
  const episodeRetry = useRef(null);
  // Video Player States
  const [isPlay, setIsPlay] = useState(true);
  const [playUrl, setPlayUrl] = useState("");
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);
  const [trailerPlayUrl, setTrailerPlayUrl] = useState(null);
  const [isAudioOn, setIsAudioOn] = useState(getTrailerAudioOnGlobal());
  const [thumbnails, setThumbnails] = useState([]);

  // Media Assets
  const [posterUrl, setPosterUrl] = useState("");
  const [verticalPosterPath, setVerticalPosterPath] = useState(null);

  // VOD & Episode Data
  const [vod, setVod] = useState(null);
  const [seasons, setSeasons] = useState(null);
  const [episodes, setEpisodes] = useState(null);
  const [selectSeason, setSelectSeason] = useState(null);
  const [selectedSeason, setSelectedSeason] = useState(null);
  const [selectedEpisode_, setSelectedEpisode_] = useState(null);

  //Binge Watching Data
  const [nextEpisode, setNextEpisode] = useState(null);
  const [nextSeason, setNextSeason] = useState(null);

  // Bookmarks
  const [bookmarkTime, setBookmarkTime] = useState(null);
  const [serieBookmark, setSerieBookmark] = useState(null);
  const [bookmarkUpdateTrigger, setBookmarkUpdateTrigger] = useState(0);

  // UI State
  const [showLoading, setShowLoading] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [showWatchNow, setShowWatchNow] = useState(false);
  const [selectedTab, setSelectedTab] = useState("details");
  const [notificationText, setNotificationText] = useState(null);
  const [showNotInProduct, setShowNotInProduct] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showMiniVodDetail, setShowMiniVodDetail] = useState(false);
  const [showSeasonOptions, setShowSeasonOptions] = useState(false);

  // Purchase
  const [canPurchase, setCanPurchase] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Refs (For Flags / Persistent State)
  const vodRef = useRef(null);
  const isRent = useRef(false);
  const previewData = useRef({});
  const seasonsRef = useRef(null);
  const episodesRef = useRef(null);
  const notInProduct = useRef(false);
  const trailerUrlRef = useRef(null);
  const nextEpisodeRef = useRef(null);
  const canPurchaseRef = useRef(false);
  const showPaymentRef = useRef(false);
  const selectedSeasonRef = useRef(null);
  const bookmarkedEpisode = useRef(null);
  const bookmarkedSeason = useRef(null);
  const nextSeasonEpisodesRef = useRef([]);
  const manuallySetNextEpisode = useRef(false); // Flag to prevent overriding manually set next episode

  // Route & Query Params
  let { vodId } = useParams();
  const history = useHistory();
  let isPipPlay = useQuery().get("pipPlay") === "1";
  let isDirectlyPlay = useQuery().get("play") === "1";
  let episodeIdFromUrl = useQuery().get("episodeId");
  let seasonIdFromUrl = useQuery().get("seasonId");
  let bookmarkTimeFromUrl = parseInt(useQuery().get("bookmarkTime")) || 0;

  // Session Context
  const {
    path,
    userFrameConfig,
    userInfo,
    setShowLoginMessage,
    showLoginMessage,
    hasLoggedIn,
    profile
  } = useContext(SessionContext);



  ///// functions /////
  const setPosters = (posters = []) => {
    // Get poster URLs using exact type strings
    const verticalPosterUrl = getPosterUrlByType(posters, "Web Portrait");
    const bannerPosterUrl = getPosterUrlByType(posters, "Web Banner");
    const landscapePosterUrl = getPosterUrlByType(posters, "Web Landscape");
    
    if (verticalPosterUrl) {
      setVerticalPosterPath(verticalPosterUrl);
    }
    
    // Prioritize banner, fallback to landscape
    const mainPosterUrl = bannerPosterUrl || landscapePosterUrl;
    if (mainPosterUrl) {
      setPosterUrl(mainPosterUrl);
    }
  };

  const processSerialSeasons = (seriesData, directlyPlay = false) => {
    console.log("🔍 DEBUG processSerialSeasons called with:", {
      seriesData: seriesData,
      seriesType: seriesData?.type,
      seriesId: seriesData?.id,
      directlyPlay: directlyPlay
    });
    
    let _seasons = seriesData.children || [];
    console.log("📋 Initial seasons from children:", _seasons);
    
    // If no children, look for seasons in relatedCatchups
    if (_seasons.length === 0 && seriesData.relatedCatchups) {
      _seasons = seriesData.relatedCatchups.filter(item => item.type === "CATCHUPSEASON");
      console.log("📋 Seasons from relatedCatchups:", _seasons);
    }
    
    seasonsRef.current = _seasons;

    setSeasons(_seasons);
    let lastSelectedSeasonIndex = null;
    const contentInfo = seriesData.lastContentInfo;
    
    // Check if we have season ID from URL (from mini modal)
    if (seasonIdFromUrl) {
      lastSelectedSeasonIndex = _seasons.findIndex(
        (item) => item.id == seasonIdFromUrl
      );
    } else if (contentInfo?.seasonId) {
      lastSelectedSeasonIndex = _seasons.findIndex(
        (item) => item.id === contentInfo.seasonId
      );
      bookmarkedSeason.current = _seasons[lastSelectedSeasonIndex];
      bookmarkedEpisode.current = contentInfo;
    }
    
    let _selectSeason = null;
    if (lastSelectedSeasonIndex && lastSelectedSeasonIndex > 0) {
      _selectSeason = _seasons[lastSelectedSeasonIndex];
    } else {
      _selectSeason = _seasons[0];
    }
    selectedSeasonRef.current = _selectSeason;
    setSelectedSeason(_selectSeason);
    
    // If we have seasons, get episodes for the selected season
    if (_seasons.length > 0) {
      getCatchupEpisodes(_selectSeason?.id, (_episodes) => {
        episodesRef.current = _episodes;
        setEpisodes(_episodes);
        
        if (directlyPlay) {
          if (bookmarkedEpisode.current) {
            continueWatchingEpisode();
          } else {
            playFirstEpisode();
          }
        }
        
        if (episodeIdFromUrl) {
          const selectedEpisode = _episodes.find(
            (item) => item.id == episodeIdFromUrl
          );
          if (selectedEpisode) {
            onSelectEpisode(selectedEpisode);
          }
        }
      });
    } else {
      // No seasons found, try to get episodes directly from series relatedCatchups
      if (seriesData.relatedCatchups) {
        const episodes = seriesData.relatedCatchups.filter(item => item.type === "CATCHUPEPISODE");
        episodesRef.current = episodes;
        setEpisodes(episodes);
        
        if (directlyPlay && episodes.length > 0) {
          if (bookmarkedEpisode.current) {
            continueWatchingEpisode();
          } else {
            playFirstEpisode();
          }
        }
        
        if (episodeIdFromUrl) {
          const selectedEpisode = episodes.find(
            (item) => item.id == episodeIdFromUrl
          );
          if (selectedEpisode) {
            onSelectEpisode(selectedEpisode);
          }
        }
      }
    }
  };

  const calcDuration = () => {
    if (vod?.type === "MOVIE") {
      return prettyTimeFormatter(vod?.duration, "minutes");
    } else {
      return `${episodes?.length || 0} ${localizationStrings.episodes}`;
    }
  };

  const playFirstEpisode = () => {
    if (episodesRef?.current?.[0]) {
      onSelectEpisode(episodesRef?.current?.[0]);
    } else {
      console.error("No episodes found to play");
    }
  };

  const continueWatchingEpisode = () => {
    if (!bookmarkedSeason.current) return;
    selectedSeasonRef.current = bookmarkedSeason.current;
    setSelectedSeason(bookmarkedSeason.current);

    const items = bookmarkedSeason.current?.children;
    if (!(Array.isArray(items) && items.length > 0)) return;
    episodesRef.current = items;
    setEpisodes(items);

    onSelectEpisode(bookmarkedEpisode.current);
  };

  const onSelectEpisode = (item) => {
    console.log("🔍 DEBUG onSelectEpisode called with:", {
      item: item,
      itemType: item?.type,
      itemId: item?.id,
      itemTitle: item?.title
    });
    
    if (notInProduct.current) {
      setShowNotInProduct(true);
    } else {
      findNextEpisode(item);
      getCatchupPlayUrl(item);
      setSelectedEpisode_(item);
      setIsPlayerOpen(true);
    }
    bookmarkedEpisode.current = null;
    bookmarkedSeason.current = null;
    manuallySetNextEpisode.current = false; // Reset flag when user manually selects episode
  };

  const findNextEpisode = (item) => {
    const activeEpisode = item;
    setNextSeason(false);
    setSelectedEpisode_(item);
    let selectedEpisodeIndex = episodesRef.current.findIndex(
      (item) => item.id === activeEpisode.id
    );
    if (selectedEpisodeIndex + 1 < episodesRef.current.length) {
      setNextEpisode(episodesRef.current[selectedEpisodeIndex + 1]);
      nextEpisodeRef.current = episodesRef.current[selectedEpisodeIndex + 1];
    } else {
      findNextSeason();
    }
  };
  
  const findNextSeason = () => {
    const _seasons = seasonsRef.current;
    let selectedSeasonIndex = _seasons.findIndex(
      (item) => item.seasonNo === selectedSeasonRef.current?.seasonNo
    );

    if (selectedSeasonIndex + 1 < _seasons.length) {
      setNextSeason(_seasons[selectedSeasonIndex + 1]);
      getNextSeasonWithFirstEpisode(_seasons[selectedSeasonIndex + 1]?.id);
    } else {
      setNextEpisode(null);
      setNextSeason(false);
    }
  };

  const watchNow = async () => {
    setShowWatchNow(false);
    getCatchupContent(true);
  };

  const watchLater = () => {
    setShowWatchNow(false);
    getCatchupContent();
  };
  /////End: functions /////

  ///// render function /////
  let rentalProduct;
  let estProduct;
  const renderActionButtons = (_vod, _episodes) => {
    // Catchup content is typically free, so simplified button logic
    return (
      <div className="action-buttons">
        <div 
          className="play-button" 
          onClick={() => {
            if (_vod?.type === "CATCHUPSERIES" && _episodes?.length > 0) {
              playFirstEpisode();
            } else if (_vod?.type === "CATCHUPMOVIE") {
              // Only call watch API for catchup movies
              getCatchupPlayUrl();
            } else {
              // For other types without episodes, cannot play
              console.log("Cannot play - need CATCHUPEPISODE or CATCHUPMOVIE, got:", _vod?.type);
            }
          }}
        >
          <span className="play-icon">▶</span>
          {localizationStrings.playNow}
        </div>
      </div>
    );
  };
  /////End: render function /////

  ///// async functions /////

  const getCatchupContent = async (directlyPlay = false) => {
    console.log("🔍 DEBUG getCatchupContent called with:", { vodId, directlyPlay });
    if (!vodId) return;
    const version = ++contentVersion.current;
    setLoadError(false);
    try {
      const { data } = await getCatchupById(vodId);
      if (!mounted.current || version !== contentVersion.current) return;
      console.log("📡 Main catchup data received:", data);
      
      if (!data?.id) throw new Error("Catchup unavailable");
      if (!directlyPlay) {
        setShowLoading(false);
      }
      setPosters(data.posters);
      vodRef.current = data;
      setVod(data);

      if (data?.type === "CATCHUPSERIES") {
        console.log("📺 Processing as CATCHUPSERIES");
        processSerialSeasons(data, directlyPlay);
      } else if (data?.type === "CATCHUPMOVIE") {
        console.log("🎬 Processing as CATCHUPMOVIE");
        // Handle single catchup movie content
        if (directlyPlay) {
          getCatchupPlayUrl();
        }
      } else {
        console.log("❓ Unknown catchup type:", data?.type);
      }
    } catch (error) {
      if (mounted.current && version === contentVersion.current) { setLoadError(true); setShowLoading(false); }
    }
  };

  const getTrailerUrl = async (id) => {
    const version = contentVersion.current;
    try {
      const { data } = await getTrailerPlayUrlById(id);
      if (!mounted.current || version !== contentVersion.current) return;
      if (data?.url) {
        setTrailerPlayUrl(data.url);
        trailerUrlRef.current = data.url;
      }
    } catch (err) {
      console.error("Error fetching trailer:", err);
    }
  };

  const getCatchupEpisodes = async (seasonId, callback) => {
    console.log("🔍 DEBUG getCatchupEpisodes called with seasonId:", seasonId);
    if (seasonId) {
      const version = ++episodeVersion.current;
      episodeRetry.current = () => getCatchupEpisodes(seasonId, callback);
      setEpisodeError(false);
      try {
        const { data } = await getCatchupEpisodesBySeason(seasonId);
        if (!mounted.current || version !== episodeVersion.current) return;
        console.log("📡 Season data received:", data);
        
        if (data?.children && data.children.length > 0) {
          console.log("✅ Found episodes in children:", data.children);
          callback(data.children);
        } else if (data?.relatedCatchups) {
          // Filter episodes from related catchups
          const episodes = data.relatedCatchups.filter(item => item.type === "CATCHUPEPISODE");
          console.log("✅ Found episodes in relatedCatchups:", episodes);
          callback(episodes);
        } else {
          callback([]);
        }
      } catch (error) {
        if (mounted.current && version === episodeVersion.current) setEpisodeError(true);
      }
    }
  };

  const getNextSeasonWithFirstEpisode = async (seasonId) => {
    if (!seasonId) return;
    const version = ++nextVersion.current;
    try {
      const { data } = await getCatchupEpisodesBySeason(seasonId);
      if (!mounted.current || version !== nextVersion.current) return;
      if (data?.id && data?.children) {
        nextSeasonEpisodesRef.current = data.children;
        setNextEpisode(data.children[0]);
        nextEpisodeRef.current = data.children[0];
      }
    } catch (error) {
      console.error("Error fetching next season episodes:", error);
    }
  };

  const getCatchupPlayUrl = async (episodeItem = null) => {
    setWhereFrom(""); //to stop fallback from picture in picture
    let contentId;
    
    console.log("🔍 DEBUG getCatchupPlayUrl called with:", {
      episodeItem: episodeItem,
      episodeType: episodeItem?.type,
      episodeId: episodeItem?.id,
      vodRefCurrent: vodRef.current,
      vodRefType: vodRef.current?.type,
      vodRefId: vodRef.current?.id
    });
    
    // Only call watch API with CATCHUPEPISODE IDs as per requirements
    if (episodeItem && episodeItem.type === "CATCHUPEPISODE") {
      // Playing a specific catchup episode
      contentId = episodeItem.id;
      console.log("✅ Using CATCHUPEPISODE ID:", contentId);
    } else if (vodRef.current?.type === "CATCHUPMOVIE") {
      // Playing a catchup movie (if such type exists)
      contentId = vodRef.current?.id;
      console.log("✅ Using CATCHUPMOVIE ID:", contentId);
    } else {
      // Cannot play - need specific CATCHUPEPISODE
      console.error("❌ Cannot play - watch API only accepts CATCHUPEPISODE IDs, got:", episodeItem?.type || vodRef.current?.type);
      setShowNotification(true);
      return;
    }

    if (contentId) {
      if (watchPending.current) return;
      watchPending.current = true;
      const version = ++watchVersion.current;
      try {
        const data = await watchCatchup(contentId);
        if (!mounted.current || version !== watchVersion.current) return;
        if (!data?.data?.url) throw new Error("Playback unavailable");
        console.log("📡 Watch API response:", data);
        if (data?.data?.url) {
          setPlayUrl(data.data.url);
          setIsPlayerOpen(true);
        }
      } catch (error) {
        if (mounted.current && version === watchVersion.current) setShowNotification(true);
      } finally {
        if (version === watchVersion.current) watchPending.current = false;
      }
    }
  };

  /////End: async functions /////

  ///// useEffect /////

  useEffect(() => {
    if (vodId) {
      setVod(null); vodRef.current = null;
      setEpisodes([]); episodesRef.current = [];
      setSelectSeason(null); setSelectedSeason(null); selectedSeasonRef.current = null;
      setNextEpisode(null); setNextSeason(null); nextEpisodeRef.current = null;
      setPosterUrl(""); setTrailerPlayUrl(null); setIsPlayerOpen(false);
      watchPending.current = false;
      setShowLoading(true);
      getCatchupContent(isDirectlyPlay);
    }
    return () => { contentVersion.current++; episodeVersion.current++; nextVersion.current++; watchVersion.current++; };
  }, [vodId]);

  // Refresh data when coming back from video player
  useEffect(() => {
    if (!isPlayerOpen && vodId && vodRef.current?.id === vodId && vod?.type === "CATCHUPSERIES") {
      getCatchupContent(false);
    }
  }, [isPlayerOpen, vodId]);



  useEffect(() => {
    if (selectSeason?.id) {
      getCatchupEpisodes(selectSeason.id, (episodes) => {
        setEpisodes(episodes);
        episodesRef.current = episodes;
      });
    }
  }, [selectSeason]);

  /////End: useEffect /////
  return (
    <div className="new-vod-detail-container" style={{ position: "relative" }}>
      {showLoading && <div role="status">{flowCopy().loading}</div>}
      {loadError && <div role="alert">{flowCopy().loadError} <button onClick={() => getCatchupContent()}>{flowCopy().retry}</button></div>}
      {episodeError && <div role="alert">{flowCopy().loadError} <button onClick={() => episodeRetry.current?.()}>{flowCopy().retry}</button></div>}
      <div className="new-vod-media-wrapper">
        {trailerPlayUrl && !isPlayerOpen ? (
          <TrailerPlayer
            playUrl={trailerPlayUrl}
            poster={posterUrl}
            isAudioOn={isAudioOn}
            isPlay={isPlay}
            isFrom={"catchupVodDetail"}
          />
        ) : (
          <img
            className="new-vod-poster"
            src={posterUrl ?? defaultDetailPoster}
            onError={() => {
              setPosterUrl(defaultDetailPoster);
            }}
          />
        )}
        <div className="media-overlay">
          <div className="new-vod-metadata-container absolute">
            <div className="title">{translateText(vod?.title)}</div>
            <div className="metadata-wrapper">
              <div className="metadata-row">
                <div className="content-type">
                  {vod?.type === "MOVIE"
                    ? localizationStrings.searchFilters.movie
                    : vod?.type === "CATCHUPSERIES"
                    ? localizationStrings.catchupTv
                    : ""}
                </div>
                <div className="content-year">{vod?.year}</div>
                <div className="content-duration">{calcDuration()}</div>
              </div>
              <div className="genre-row">
                <div className="content-indicators">
                  <div className="rating">
                    {vod?.maturityRating?.age === "G" ? (
                      <RtukGeneralIcon />
                    ) : vod?.maturityRating?.age === "7+" ? (
                      <RtukSevenAgeIcon />
                    ) : vod?.maturityRating?.age === "13+" ? (
                      <RtukThirteenAgeIcon />
                    ) : vod?.maturityRating?.age === "18+" ? (
                      <RtukAgeIcon />
                    ) : null}
                  </div>
                  {getParentalAdvisoryElements(vod?.maturityRating?.categories)}
                </div>
                {vod?.genre?.map((item, index) => {
                  const uniqueKey = `${item?.id}-${index}`;
                  return (
                    <>
                      <NavLink
                        key={uniqueKey}
                        className="link"
                        to={{
                          pathname: `/dashboard/search/${item}`
                        }}
                      >
                        {item}
                      </NavLink>
                      {!(vod.genre.length - 2 < index) ? (
                        <span className="dot">
                          {`${
                            vod.genre.length - 2 < index ? "" : " •"
                          }`}
                        </span>
                      ) : null}
                    </>
                  );
                })}
                {vod?.imdbRating ? (
                  <div className="imdb-rating">
                    <span>
                      <StarIcon />
                    </span>
                    IMDb {vod?.imdbRating}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="new-vod-buttons-wrapper">
              {renderActionButtons(vod, episodes)}
              <FavoriteAction vod={vod} newVodDetail />
              <LikeAction vod={vod} newVodDetail />
              <ShareAction vod={vod} newVodDetail />
            </div>
          </div>
        </div>
      </div>
      <div className="new-vod-details-wrapper">
        <div className="content-info-row">
          {episodes?.length > 0 && (
            <div
              className={`info-tab ${
                selectedTab === "episodes" ? "selected" : ""
              }`}
              onClick={() => setSelectedTab("episodes")}
            >
              {localizationStrings.episodes}
            </div>
          )}
          <div
            className={`info-tab ${
              selectedTab === "details" ? "selected" : ""
            }`}
            onClick={() => setSelectedTab("details")}
          >
            {localizationStrings.details}
          </div>
          <div
            className={`info-tab ${selectedTab === "cast" ? "selected" : ""}`}
            onClick={() => setSelectedTab("cast")}
          >
            {localizationStrings.cast}
          </div>
        </div>
        {selectedTab === "episodes" ? (
          <div className="season-wrapper">
            <div
              className={`season-select-box ${
                showSeasonOptions ? "opened" : ""
              }`}
              onClick={() => setShowSeasonOptions(!showSeasonOptions)}
            >
              <div className="selected-season">
                <span>
                  {localizationStrings.season} {selectedSeason?.seasonNo}
                </span>
                <ArrowDownIcon />
              </div>

              <div
                className={`season-options ${showSeasonOptions ? "show" : ""}`}
              >
                {seasons?.map((item, index) => {
                  const uniqueKey = `${item?.id}-${index}`;

                  return (
                    <div
                      key={uniqueKey}
                      className="option"
                      onClick={() => {
                        setSelectedSeason(item);
                        setSelectSeason(item);
                        selectedSeasonRef.current = item;
                        setShowSeasonOptions(false);
                      }}
                    >
                      <span>
                        {localizationStrings.season} {item?.seasonNo}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="episodes-wrapper">
              {episodes?.map((_episode) => {
                return (
                  <NewEpisodeItem
                    key={_episode?.id}
                    episode={_episode}
                    onSelectEpisode={(item) => {
                      if (!manuallySetNextEpisode.current) {
                        manuallySetNextEpisode.current = true;
                      }
                      onSelectEpisode(item);
                    }}
                    loading={showLoading}
                  />
                );
              })}
            </div>
          </div>
        ) : selectedTab === "details" ? (
          <div className="details-wrapper">
            <div className="details-section">
              <div className="details-title">
                {localizationStrings.countryOfOrigin}
              </div>
              <div className="details-body">
                {vod?.country ?? localizationStrings.noData}
              </div>
            </div>
            <div className="details-section">
              <div className="details-title">
                {localizationStrings.storyline}
              </div>
              <div className="details-body">{translateText(vod?.description || vod?.summaryLong)}</div>
            </div>
            <div className="details-section">
              <div className="details-title">{localizationStrings.genres}</div>
              <div className="details-body">
                {vod?.genre?.map((item, index) => {
                  const uniqueKey = `${item?.id}-${index}`;
                  return (
                    <>
                      <NavLink
                        key={uniqueKey}
                        className="link"
                        to={{
                          pathname: `/dashboard/search/${item}`
                        }}
                      >
                        {item}
                      </NavLink>
                      {!(vod.genre.length - 2 < index) ? (
                        <span className="dot">
                          {`${
                            vod.genre.length - 2 < index ? "" : " •"
                          }`}
                        </span>
                      ) : null}
                    </>
                  );
                })}
              </div>
            </div>
          </div>
        ) : selectedTab === "cast" ? (
          <div className="casts-wrapper">
            {vod?.actors &&
              vod.actors.map((cast) => (
                <div key={cast?.id || cast?.name} className="cast-item">
                  <div className="cast-image">
                    <img
                      src={cast?.poster || defaultCastPoster}
                      onError={(e) => {
                        e.target.src = defaultCastPoster;
                      }}
                      alt={cast?.name}
                    />
                  </div>
                  <div className="cast-name">{cast?.name}</div>
                  <div className="cast-role">{cast?.role}</div>
                </div>
              ))}
          </div>
        ) : null}
        {showMiniVodDetail ? (
          <MiniVodDetail
            vodData={previewData.current}
            closeModal={() => {
              setShowMiniVodDetail(false);
            }}
            isVodDetail={true}
          />
        ) : null}
      </div>
      {isPlayerOpen ? (
        <Modal viewClass={`player-modal`}>
          <VideoPlayer
            key="catchup-player"
            options={playerOptions}
            src={playUrl}
            vod={vod}
            thumbnails={thumbnails}
            isTimeshiftEnable={true}
            addContentToFavorite={() => {}}
            removeContentFromFavorite={() => {}}
            setBookmarkTime={(val) => {
              setBookmarkTime(val);
            }}
            bookmarkTime={bookmarkTime}
            showAd={false}
            closePlayer={(val) => {
              watchVersion.current++;
              watchPending.current = false;
              if (val) {
                if (isDirectlyPlay || isPipPlay) {
                  history.push(path);
                } else {
                  setBookmarkUpdateTrigger(value => value + 1);
                }
              }
              
              setIsPlayerOpen(false);
              if (val?.isCompleted) {
                setBookmarkUpdateTrigger(bookmarkUpdateTrigger + 1);
              }
            }}
            nextEpisode={nextEpisode}
            nextSeason={nextSeason}
            selectedSeason={selectedSeason}
            selectedEpisode={selectedEpisode_}
            playNextEpisode={() => {
              if (nextEpisode) {
                onSelectEpisode(nextEpisode);
              } else if (nextSeason) {
                selectedSeasonRef.current = nextSeason;
                setSelectedSeason(nextSeason);
                if (nextSeasonEpisodesRef.current?.length > 0) {
                  episodesRef.current = nextSeasonEpisodesRef.current;
                  setEpisodes(nextSeasonEpisodesRef.current);
                  onSelectEpisode(nextSeasonEpisodesRef.current[0]);
                }
              }
            }}
            isFav={false}
            isPreview={false}
            isCutvVod={!!vod?.channelcode}
            poster={posterUrl}
          />
        </Modal>
      ) : null}
      {showWatchNow ? (
        <Notification
          text={localizationStrings.watchNowText}
          confirmText={localizationStrings.watchNow}
          notConfirmText={localizationStrings.watchLater}
          onClickConfirm={() => watchNow()}
          onClickNotConfirm={() => watchLater()}
        />
      ) : null}

      {showNotification ? (
        <Notification
          text={flowCopy().error}
          confirmText={localizationStrings.close}
          onClickConfirm={() => setShowNotification(false)}
        />
      ) : null}

      {showNotInProduct ? (
        <Notification
          text={localizationStrings.outOfProduct}
          confirmText={localizationStrings.packages}
          icon={<PackageIcon />}
          onClickConfirm={() => history.push("/dashboard/package")}
          onClickNotConfirm={() => {
            setShowNotInProduct(false);
          }}
          showCloseButton={true}
        />
      ) : null}
    </div>
  );
};

export default CatchupVodDetail;
